let API_DOMAIN = "http://localhost:3001";
let IdPropertyName = "id";

switch (process.env.REACT_APP_EPA_ENV) {
  case "localhost":
    API_DOMAIN = "http://localhost:3001"; //using https://github.com/typicode/json-server#alternative-port
    break;

  case "inttest":
    API_DOMAIN = "https://data-int.epa.ie/leap/api/v1";
    break;

  case "bustest":
    API_DOMAIN = "https://data-tst.epa.ie/leap/api/v1";
    //API_DOMAIN = "http://leapapi-tst.edenireland.ie:8188/api/v1";
    break;

  case "staging":
    API_DOMAIN = "https://data-stg.epa.ie/leap/api/v1";
    break;

  case "production":
    API_DOMAIN = "https://data.epa.ie/leap/api/v1";
    break;
}
export const ENV = API_DOMAIN;
export const API_URL_ODATA = `${ENV}/odata`;
export const API_URL = `${ENV}`;
